import { AiOutlineFileAdd, AiOutlineLogout } from 'react-icons/ai'
import { BiCoinStack } from 'react-icons/bi'
//import { BiPurchaseTagAlt } from 'react-icons/bi'
import { BsDatabaseAdd, BsPencil } from 'react-icons/bs'
import { HiOutlineDocumentReport} from 'react-icons/hi'
//import { HiOutlineTemplate } from 'react-icons/hi'
import { HiOutlineClipboardDocumentList } from 'react-icons/hi2'
import { MdProductionQuantityLimits } from 'react-icons/md'
import { TbCoins } from 'react-icons/tb'
export const MenuData = [
  {
    title: 'Componentes',
    icon: <MdProductionQuantityLimits />,
    link: '/',
  },
  {
    title: 'Produtos',
    icon: <BsPencil />,
    link: '/create_products',
  },
  {
    title: 'Lista de produtos',
    icon: <HiOutlineClipboardDocumentList />,
    link: '/list_products',
  },
  {
    title: 'Despesas',
    icon: <BiCoinStack />,

    subitems: [
      { title: 'Fixos', icon: <TbCoins />, link: '/fixed' },
      //{ title: 'Variáveis', icon: <TbCoins />, link: '/variables' },
      //{ title: 'Vendas', icon: <BiPurchaseTagAlt />, link: '/sales' },
      //{ title: 'Plataformas', icon: <HiOutlineTemplate />, link: '/expenses' },
    ],
  },
  {
    title: 'Cadastros',
    icon: <AiOutlineFileAdd />,
    subitems: [
      /*{
        title: 'Cadastro de vendas',
        icon: <BsDatabaseAdd />,
        link: '/new_sales',
      },*/

      {
        title: 'Importação',
        icon: <BsDatabaseAdd />,
        link: '/import',
      },
    ],
  },

  {
    title: 'Relatórios',
    icon: <HiOutlineDocumentReport />,
    link: '#',
    subitems: [
      //{ title: 'Relatório 1', icon: <HiOutlineDocumentReport />, link: '/reports1' },
      //{ title: 'Relatório 2', icon: <HiOutlineDocumentReport />, link: '/reports2' },
    ],
  },

  {
    title: 'Sair',
    icon: <AiOutlineLogout />,
  },
]
